import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";
import useTimeout from "../../../common/hooks/useTimeout";

type FadeTransitionProps = {
  cls: string;
  enter?: number;
  exit?: number;
  in?: boolean;
  unmountOnExit?: boolean;
  appear?: boolean;
  children?: React.ReactNode;
};
export const FadeTransition = ({ cls, enter = 250, exit = 250, ...props }: FadeTransitionProps) => (
  <CSSTransition classNames={cls} timeout={{ enter, exit }} {...props} />
);

export const DelayFadeTransition = ({
  delay,
  ...props
}: FadeTransitionProps & { delay?: number }) => {
  const [delayIn, setDelayIn] = useState(props.in ?? false);
  useTimeout(() => setDelayIn(true), delay);
  return <FadeTransition {...props} in={delayIn} />;
};
